import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import CookieService from "../../context/cookies";

import { base } from "../../constants/apis";
import { ApiResponse } from "../../types/ApiResponse";

export type MailAlert = {
  id: number;
  uid: number;
  shipments_status: 0 | 1;
  shipments_interval: string;
  payables_status: 0 | 1;
  payables_interval: string;
  receivables_status: 0 | 1;
  receivables_interval: string;
  email_list: string[];
  created_at: string;
};

export const dealTrackerMailAlertApi = createApi({
  reducerPath: "dealTrackerMailAlertApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/deal_tracker_mail_notification`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["dtMailAlert"],
  endpoints: (builder) => ({
    getMailAlert: builder.query<MailAlert, void>({
      query: () => "get.php",
      transformResponse: (res: ApiResponse<MailAlert>) => res.data,
      providesTags: ["dtMailAlert"],
    }),

    addMailAlert: builder.mutation({
      query: (payload) => ({
        url: "/add.php",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["dtMailAlert"],
    }),

    updateMailAlert: builder.mutation({
      query: (payload) => ({
        url: "/update.php",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["dtMailAlert"],
    }),
  }),
});

export const {
  useAddMailAlertMutation,
  useGetMailAlertQuery,
  useUpdateMailAlertMutation,
} = dealTrackerMailAlertApi;
